import markdownItEmoticons from 'markdown-it-emoji/lib/data/shortcuts.mjs'

export function normalizeEmoji (str) {
  if (typeof str !== 'string') return
  // Iterating gets the meaningful parts
  // (can be different number of iterations to .length)
  const parts = Array.from(str)
  // Not sure why, but longer ones can end in FE0F, but shorter ones can't...
  // FE0F is a "variation selector" just to say "render as an emoji"
  if (parts.length < 3 && parts[parts.length - 1] === '\u{FE0F}') {
    parts.pop()
  }
  return parts.join('')
}

export function emojiToHexCode (str) {
  return Array.from(normalizeEmoji(str)).map(c =>
    c.codePointAt(0)
      .toString(16)
      .toUpperCase()
      .padStart(4, '0'))
    .join('-')
}

export function hexcodeToEmoji (hexcode) {
  return hexcode.split('-').map(part => String.fromCodePoint(parseInt(part, 16))).join('')
}

export function stringToHex (str) {
  return Array.from(str).map(s => s.codePointAt(0).toString(16).padStart(4, '0')).join('-')
}

// Use a more basic smile for the default normal simple smile
export const emoticons = { ...markdownItEmoticons }
emoticons.slightly_smiling_face = emoticons.smiley
delete emoticons.smiley
